import { render, staticRenderFns } from "./com-num-people.vue?vue&type=template&id=724ba4d7&scoped=true"
import script from "./com-num-people.vue?vue&type=script&lang=js"
export * from "./com-num-people.vue?vue&type=script&lang=js"
import style0 from "./com-num-people.vue?vue&type=style&index=0&id=724ba4d7&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ba4d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('724ba4d7')) {
      api.createRecord('724ba4d7', component.options)
    } else {
      api.reload('724ba4d7', component.options)
    }
    module.hot.accept("./com-num-people.vue?vue&type=template&id=724ba4d7&scoped=true", function () {
      api.rerender('724ba4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modulestore/components/com-num-people.vue"
export default component.exports